import Alpine from 'alpinejs';
window.Alpine = Alpine;

// Bild-/Font-Assets ins Manifest zwingen, damit Vite::asset() sie in Blade auflösen kann.
// eager + Zuweisung nötig: Vite 8 entfernt den ungenutzten Glob sonst per Tree-Shaking → 500 wegen fehlender Manifest-Keys.
window.assets = import.meta.glob(['../images/**', '../fonts/**'], { eager: true, query: '?url', import: 'default' });
import.meta.glob(['./../../blocks/src/**/block.css'], { eager: true });

// project-request registriert eine Alpine-Factory (window.initProjectRequest) und muss vor Alpine.start() global sein → eager
import './../../blocks/src/blocks/project-request/block.js';

// Übrige Block-Skripte (inkl. ihrer Libraries) erst laden, wenn der Block wirklich im DOM ist
const blockModules = import.meta.glob([
	'./../../blocks/src/**/block.js',
	'!**/project-request/block.js',
]);

import { setIdForAllSwipers } from '@scripts/swiperfunctions';
setIdForAllSwipers();

import '@scripts/menu';
import '@scripts/scrollReveal';
import '@scripts/components/spotify';
import '@scripts/components/alpakaGame';

import '@scripts/utilities/overlay';
import '@scripts/utilities/darkmodeToggle';
import '@scripts/utilities/headerVisibility';
import '@scripts/utilities/shareButtons';

Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
	loadModules();
});

// Lädt für jeden im DOM vorhandenen Block (data-component="block-…") das passende block.js und ruft dessen init() auf
async function loadModules() {
	const present = new Set(
		[...document.querySelectorAll('[data-component^="block-"]')]
			.map((el) => el.dataset.component.slice('block-'.length))
	);

	await Promise.all(
		Object.entries(blockModules)
			.filter(([path]) => present.has(path.match(/blocks\/([^/]+)\/block\.js$/)[1]))
			.map(async ([, load]) => {
				const mod = await load();
				mod.default?.();
			})
	);
}
